(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-free-badge"] && !Shopify.designMode) return;
  try {
    
  class CartFreeBadge extends HTMLElement {
    static styleId = 'cart-free-badge-style';
    static events = ['cart:add', 'cart:changed', 'cart:refresh'];
    #abort = null;
    #timer = 0;

    connectedCallback() {
      this.#abort = new AbortController();
      for (const name of CartFreeBadge.events) {
        document.addEventListener(name, () => this.#schedule(), { signal: this.#abort.signal });
      }
      this.#schedule();
    }

    disconnectedCallback() {
      this.#abort?.abort();
      window.clearTimeout(this.#timer);
    }

    #schedule() {
      window.clearTimeout(this.#timer);
      this.#timer = window.setTimeout(() => this.#refresh(), 200);
    }

    async #refresh() {
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`${this.dataset.cartUrl} responded ${response.status}`);
        const cart = await response.json();
        this.#write(CartFreeBadge.freeLineKeys(cart));
      } catch (error) {
        console.error('cart-free-badge', { event: 'refresh_failed', message: error?.message ?? String(error) });
      }
    }

    #write(keys) {
      let style = document.getElementById(CartFreeBadge.styleId);
      if (keys.length === 0) {
        style?.remove();
        return;
      }
      if (!style) {
        style = document.createElement('style');
        style.id = CartFreeBadge.styleId;
        document.head.appendChild(style);
      }
      style.textContent = CartFreeBadge.css(keys, this.dataset.label || 'Grátis');
    }

    static freeLineKeys(cart) {
      const items = Array.isArray(cart?.items) ? cart.items : [];
      return items
        .filter((item) => Number(item.original_line_price) > 0 && Number(item.final_line_price) === 0)
        .map((item) => String(item.key));
    }

    static css(keys, label) {
      const selectors = keys
        .map((key) => `.cart-drawer__item[data-line-key=${JSON.stringify(key)}] .cart-drawer__item-content::after`)
        .join(',\n');
      return `${selectors} {
  content: ${JSON.stringify(label)};
  flex-shrink: 0;
  align-self: center;
  margin-inline-start: auto;
  padding: 0.4rem 0.8rem;
  border-radius: 0.4rem;
  background-color: #dcfce7;
  color: #16a34a;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}
`;
    }
  }

  if (!customElements.get('cart-free-badge')) {
    customElements.define('cart-free-badge', CartFreeBadge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-scroll-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-scroll-stats')) {
    const svScrollStatsTiming = Object.freeze({
      line: 0.6,
      accent: 0.45,
      hold: 0.1,
      desktopStart: 0.15,
      centerStart: 0.5,
    });
    const svScrollStatsCenterQuery = '(max-width: 991px)';
    const svScrollStatsReducedQuery = '(prefers-reduced-motion: reduce)';

    const svScrollStatsClamp = (value) => Math.min(Math.max(value, 0), 1);
    const svScrollStatsEaseOut = (value) => 1 - (1 - value) ** 3;
    const svScrollStatsSegment = (time, start, duration) =>
      svScrollStatsEaseOut(svScrollStatsClamp((time - start) / duration));

    const svScrollStatsSetVar = (element, name, value) => {
      if (element && element.style.getPropertyValue(name) !== value) {
        element.style.setProperty(name, value);
      }
    };

    const svScrollStatsCreateMask = (text) => {
      const mask = document.createElement('span');
      const line = document.createElement('span');
      mask.className = 'sv-scroll-stats__mask';
      line.className = 'sv-scroll-stats__line';
      line.textContent = text;
      mask.append(line);
      return mask;
    };

    const svScrollStatsVisualLines = (stat, text) => {
      const mask = svScrollStatsCreateMask('');
      const words = text
        .split(' ')
        .map((word) => Object.assign(document.createElement('span'), { textContent: word }));
      words.forEach((word, index) => mask.firstChild.append(index ? ' ' : '', word));
      stat.replaceChildren(mask);
      const rows = new Map();
      words.forEach((word) =>
        rows.set(word.offsetTop, [...(rows.get(word.offsetTop) || []), word.textContent]),
      );
      return Array.from(rows.values(), (row) => row.join(' '));
    };

    class SvScrollStats extends HTMLElement {
      #panel = null;
      #content = null;
      #gummy = null;
      #stats = [];
      #lines = [];
      #mode = '';
      #width = 0;
      #layout = { height: 0, startTop: 0 };
      #viewport = { width: 0, height: 0 };
      #near = false;
      #frame = 0;
      #refreshFrame = 0;
      #abort = null;
      #observers = [];

      connectedCallback() {
        this.#panel = this.querySelector('.sv-scroll-stats__panel');
        this.#content = this.querySelector('.sv-scroll-stats__content');
        if (!this.#panel || !this.#content) return;
        this.#gummy = this.querySelector('.sv-scroll-stats__gummy');
        this.#stats = Array.from(this.querySelectorAll('.sv-scroll-stats__stat'), (element) => ({
          element,
          text: element.textContent.replace(/\s+/g, ' ').trim(),
        }));
        this.#viewport = { width: window.innerWidth, height: window.innerHeight };
        this.#listen();
        this.#refresh(true);
        document.fonts?.ready.then(() => this.isConnected && this.#refresh(true));
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observers.forEach((observer) => observer.disconnect());
        this.#observers = [];
        cancelAnimationFrame(this.#frame);
        cancelAnimationFrame(this.#refreshFrame);
        this.#frame = 0;
        this.#refreshFrame = 0;
      }

      #listen() {
        this.#abort = new AbortController();
        const options = { passive: true, signal: this.#abort.signal };
        window.addEventListener('scroll', this.#onScroll, options);
        window.addEventListener('resize', this.#onResize, options);
        window
          .matchMedia(svScrollStatsReducedQuery)
          .addEventListener('change', this.#requestRefresh, options);
        const resize = new ResizeObserver(this.#requestRefresh);
        const intersection = new IntersectionObserver(this.#onIntersect, { rootMargin: '50% 0px' });
        resize.observe(this.#panel);
        resize.observe(this.#content);
        intersection.observe(this);
        this.#observers = [resize, intersection];
      }

      #onScroll = () => {
        if (this.#near) this.#requestFrame();
      };

      #onIntersect = ([entry]) => {
        this.#near = entry.isIntersecting;
        this.#requestFrame();
      };

      #onResize = () => {
        const width = window.innerWidth;
        const heightOnly = width === this.#viewport.width;
        if (heightOnly && window.matchMedia('(pointer: coarse)').matches) return;
        this.#viewport = { width, height: window.innerHeight };
        this.#requestRefresh();
      };

      #requestRefresh = () => {
        cancelAnimationFrame(this.#refreshFrame);
        this.#refreshFrame = requestAnimationFrame(() => this.#refresh());
      };

      #requestFrame() {
        if (!this.#frame) this.#frame = requestAnimationFrame(this.#tick);
      }

      #tick = () => {
        this.#frame = 0;
        this.#update();
      };

      #refresh(force = false) {
        this.#refreshFrame = 0;
        if (window.matchMedia(svScrollStatsReducedQuery).matches) {
          if (this.#mode !== 'static') this.#reset();
          return;
        }
        this.#mode = 'motion';
        const width = this.#content.clientWidth;
        if (force || width !== this.#width) this.#split(width);
        this.#measure();
        this.#update();
      }

      #split(width) {
        this.#width = width;
        this.#stats.forEach(({ element, text }) => {
          const rows = svScrollStatsVisualLines(element, text);
          element.replaceChildren(...rows.map((row) => svScrollStatsCreateMask(row)));
          this.#describe(element, text, rows.length > 1);
        });
        this.#lines = Array.from(this.querySelectorAll('.sv-scroll-stats__line'));
      }

      #describe(element, text, isSplit) {
        if (!isSplit) {
          element.removeAttribute('aria-label');
          return;
        }
        element.setAttribute('aria-label', text);
        element
          .querySelectorAll('.sv-scroll-stats__mask')
          .forEach((mask) => mask.setAttribute('aria-hidden', 'true'));
      }

      #measure() {
        const { hold, centerStart, desktopStart } = svScrollStatsTiming;
        const height = this.#content.offsetHeight;
        const box = this.#content.getBoundingClientRect();
        const offset = box.top - this.#panel.getBoundingClientRect().top;
        const viewport = this.#viewport.height;
        const centered = window.matchMedia(svScrollStatsCenterQuery).matches;
        const pinTop = centered ? viewport / 2 - offset - box.height / 2 : -offset;
        const startOffset = centered
          ? offset + box.height / 2 - viewport * centerStart
          : offset - viewport * desktopStart;
        const documentTop = this.getBoundingClientRect().top + window.scrollY;
        this.#layout = { height, startTop: documentTop - Math.round(documentTop + startOffset) };
        svScrollStatsSetVar(this, '--sv-scroll-stats-pin-top', `${pinTop}px`);
        svScrollStatsSetVar(this, '--sv-scroll-stats-pin-space', `${height * (1 + hold)}px`);
      }

      #update() {
        const { height, startTop } = this.#layout;
        if (this.#mode !== 'motion' || !height) return;
        const { line, accent } = svScrollStatsTiming;
        const progress = svScrollStatsClamp((startTop - this.getBoundingClientRect().top) / height);
        const time = progress * (this.#lines.length * line + accent);
        this.#lines.forEach((element, index) => {
          const shown = svScrollStatsSegment(time, index * line, line);
          svScrollStatsSetVar(
            element,
            '--sv-scroll-stats-line-y',
            `${((1 - shown) * 100).toFixed(3)}%`,
          );
        });
        this.#paintAccent(svScrollStatsSegment(time, this.#lines.length * line, accent));
      }

      #paintAccent(accent) {
        const value = accent.toFixed(5);
        svScrollStatsSetVar(this.#stats.at(-1)?.element, '--sv-scroll-stats-accent', value);
        svScrollStatsSetVar(this.#gummy, '--sv-scroll-stats-accent', value);
      }

      #reset() {
        this.#mode = 'static';
        this.#width = 0;
        this.#layout = { height: 0, startTop: 0 };
        this.style.removeProperty('--sv-scroll-stats-pin-top');
        this.style.removeProperty('--sv-scroll-stats-pin-space');
        this.#stats.forEach(({ element, text }) => {
          element.replaceChildren(svScrollStatsCreateMask(text));
          this.#describe(element, text, false);
        });
        this.#lines = [];
        this.#stats.at(-1)?.element.style.removeProperty('--sv-scroll-stats-accent');
        this.#gummy?.style.removeProperty('--sv-scroll-stats-accent');
      }
    }

    customElements.define('sv-scroll-stats', SvScrollStats);
  }

  } catch(e) { console.error(e); }
})();
})();
